import * as t from './actionTypes';
import * as api from './api';

export function loadEvents(successCB, errorCB) {
    return (dispatch) => {
        api.getEvents(function (success, events, error) {
            if (success) {
                dispatch({ type: t.EVENT_LOAD_SUCCESS, events: events });
                successCB();
            } else if (error)
                errorCB(error);
        })
    }
}

export function createNewEvent(data, successCB, errorCB) {
    return (dispatch) => {
        api.createNewEvent(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.EVENT_CREATE_SUCCESS, event: data });
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}

export function editEvent(id, data, successCB, errorCB) {
    return (dispatch) => {
        api.editEvent(id, data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.EVENT_EDIT_SUCCESS, id: id, event: data });
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}

export function changeFeature(id, value, successCB, errorCB) {
    return (dispatch) => {
        api.changeFeature(id, value, function(success, data, error) {
            if (success) {
                dispatch({ type: t.EVENT_CHANGE_FEATURED_SUCCESS, id: id});
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}

export function changeStarred(id, value, successCB, errorCB) {
    return (dispatch) => {
        api.changeStarred(id, value, function(success, data, error) {
            if (success) {
                dispatch({ type: t.EVENT_CHANGE_STARRED_SUCCESS, id: id});
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}

export function deleteEvent(id, successCB, errorCB) {
    return (dispatch) => {
        api.deleteEvent(id, function(success, error) {
            if (success) {
                dispatch({ type: t.EVENT_DELETE_SUCCESS, id: id });
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}


export function deleteAllEventOccurrences(id, successCB, errorCB) {
    return (dispatch) => {
        api.deleteAllEventOccurrences(id, function(success, error) {
            if (success) {
                dispatch({ type: t.EVENT_DELETE_SUCCESS, id: id });
                successCB();
            } else if (error) {
                errorCB(error);
            }
        })
    }
}

export function saveSpecials(data) {
    return (dispatch) => {
        api.saveSpecials(data, function(success, error) {
            if (success) {
                dispatch({ type: t.SPECIAL_SAVE, payload: data });
            } else {
                console.log(error);
            }
        })
    }
}

export function loadSpecials(cb) {
    return (dispatch) => {
        dispatch({ type: t.SPECIAL_SET_LOADING });

        api.loadSpecials(function(success, data, error) {
            if (success) {
                dispatch({ type: t.SPECIAL_SAVE, payload: data });
                cb();
            } else {
                console.log(error);
            }

            dispatch({ type: t.SPECIAL_UNSET_LOADING });
        })
    }
}
